module.exports = __webpack_public_path__ + "img/divider-4.738e18a7.jpg";